import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function WhatYouLearn() {
  const learnings = ['Qué es la inflamación crónica y por qué afecta más a las mujeres', 'Qué alimentos inflaman tu cuerpo sin que lo notes', 'Cómo apoyar tu digestión e intestino (tu segundo cerebro)', 'Cómo construir un plato antiinflamatorio en cada comida', 'Cómo reducir la carga inflamatoria desde hábitos reales', 'Cómo integrar movimiento, descanso y manejo del estrés', 'Cómo crear una rutina sostenible que se mantenga en el tiempo'];
  return <section className="w-full px-4 py-20 bg-ivory" data-id="element-378">
      <div className="max-w-4xl mx-auto" data-id="element-379">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-380">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-6" data-id="element-381">
            Qué vas a aprender
          </h2>
        </motion.div>

        <div className="bg-cream p-8 md:p-12 rounded-3xl shadow-sm border border-taupe/10" data-id="element-382">
          <ul className="space-y-6" data-id="element-383">
            {learnings.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-384">
                <Leaf className="w-6 h-6 text-sage shrink-0 mt-0.5" data-id="element-385" />
                <span className="text-lg text-ink/90" data-id="element-386">{item}</span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}